import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiUrl } from '@brand-lolly/app/_services/base-api-urls';
import { Observable } from 'rxjs';
import { ProductId } from '@brand-lolly/app/billing/types/product.types';
import {
	CancelRequest,
	CancelResponse
} from '@brand-lolly/app/billing/types/mutations.types';
import { idempotencyHeaders } from './idempotency.util';

export interface ICancelSubscriptionService {
	cancel(
		productId: ProductId,
		request?: CancelRequest
	): Observable<CancelResponse>;
}

@Injectable({ providedIn: 'root' })
export class CancelSubscriptionService implements ICancelSubscriptionService {
	private readonly url = `${BaseApiUrl.SocialMessengerPython}billing/cancel`;

	constructor(private http: HttpClient) {}

	cancel(
		productId: ProductId,
		request: CancelRequest = {}
	): Observable<CancelResponse> {
		const params = new HttpParams().set('product_id', String(productId));
		return this.http.post<CancelResponse>(this.url, request, {
			headers: idempotencyHeaders(),
			params
		});
	}
}
